export const UI_TEXT_GENERAL_INFOS = {
	title: "Dados gerais",
	subtitle: "Preencher seus dados para proseguir",
	checklistTypeLabel: "Tipo",
	checklistTypePlaceholder: "Tipo de checklist",
	odometerLabel: "Hodômetro (km)",
	odometerPlaceholder: "Hodômetro do veículo",
	fuelLevelLabel: "Nível de combustível",
	fuelLevelRequired: "Nível de combustível é obrigatória",
	requiredField: "Informação obrigatória.",
	invalidField: "Digite um valor válido",
	submitButton: "Continuar",
};
